/**
 * O /Payments devolvia a lista crua e passou a devolvê-la embrulhada em `payment_options`. As duas
 * formas convivem entre ambientes; quem lê a resposta passa por aqui em vez de conhecer o formato.
 * Devolve a própria lista da resposta (não uma cópia) ou null quando não há lista.
 */
export function readPaymentOptions (data) {
  if (Array.isArray(data)) {
    return data
  }
  return data && Array.isArray(data.payment_options) ? data.payment_options : null
}
